import { Editor, Path, Text, Node } from 'slate'

/**
 * 
 * @returns If the given node can be selected to add `{ break: true }`
 */
export function checkIfBreakIsNeeded(editor: Editor, node: Node, path: Path) {
  if (!Text.isText(node)) return false

  const [parent, parentPath] = Editor.parent(editor, path)

  return (
    node.text === '' &&
    !node['break'] &&
    parent['type'] === 'fragment' &&
    parent.children.at(-1) === node &&
    Editor.string(editor, parentPath) === ''
  )
}
/**
 * 
 * @returns If the given node can be selected to remove `{ break: true }`
 */
export function checkIfBreakIsNeededToRemove(editor: Editor, node: Node, path: Path) {
  if (!Text.isText(node)) return false

  const [parent, parentPath] = Editor.parent(editor, path)

  return (
    node.text !== '' &&
    node['break'] &&
    parent['type'] === 'fragment'
  )
}

